export default __webpack_public_path__ + "static/media/tesla.cdfdd692.png";